const pdpWishlistButton = document.querySelector('product-info .button--wishlist');
if (pdpWishlistButton && window.wishlistConfig && window.wishlistConfig.type === 'product') {

  const mutationObserver = new MutationObserver(entries => {
    entries.forEach((btn) => {
      if(btn.target.dataset.variantId !== btn.target.dataset.originalVariantId) {
        btn.target.dataset.variantId = btn.target.dataset.originalVariantId;
        document.dispatchEvent(new CustomEvent('swym:initializeActionButtons'));
      }
    });
  });

  mutationObserver.observe(pdpWishlistButton, {
    attributes: true,
    attributeOldValue: true,
    attributeFilter: ['data-variant-id']
  });
}

const fetchList = async (swat) => {
  return new Promise((resolve, reject) => {
    const onSuccess = (lists) => {
      window.swymWishLists = lists;
      window.swymSelectedListId = lists && lists[0] && lists[0].lid;
      resolve(lists);
    };

    const onError = (error) => {
      console.log('Error fetching wishlist', error);
      reject(error);
    };

    if(!window.swymWishLists) {
      swat.fetchLists({
        callbackFn: onSuccess,
        errorFn: onError
      });
    } else {
      resolve(window.swymWishLists);
    }
  });
};

(function() {
  function navUpdateListeners(swat) {
    swat.evtLayer.addEventListener('sw:addedtowishlist', (e) => {
      document.querySelectorAll('[data-wishlist-count]').forEach(el => {
        const currentCount = parseInt(el.textContent || 0);
        el.textContent = currentCount + 1;
        document.querySelector('.header__icon--wishlist').classList.toggle('hidden', (currentCount + 1) === 0);
      });
    });

    swat.evtLayer.addEventListener('sw:removedfromwishlist', (e) => {
      document.querySelectorAll('[data-wishlist-count]').forEach(el => {
        const currentCount = parseInt(el.textContent || 0);
        document.querySelector('.header__icon--wishlist').classList.toggle('hidden', (currentCount - 1) === 0);
        el.textContent = currentCount - 1;
      });
    });
  }
  async function updateNav(swat) {
    try {
      const wishlistObj = await fetchList(swat);
      const wishlistCount = wishlistObj[0]?.listcontents?.length || 0;

      document.querySelectorAll('[data-wishlist-count]').forEach(el => el.textContent = wishlistCount);
      document.querySelector('.header__icon--wishlist')?.classList.toggle('hidden', wishlistCount === 0);

    } catch(error) {
      console.error('Error loading wishlist object', error);
    }
/*
    swat.fetch((products) => {
      const wishlistCount = (
        window.wishlistConfig && window.wishlistConfig.type === 'variant' ?
          products.length :
          Array.from(new Set(products.map(el => el.du))).length
      ) || 0;
      document.querySelectorAll('[data-wishlist-count]').forEach(el => el.textContent = wishlistCount);
      document.querySelector('.header__icon--wishlist').classList.toggle('hidden', wishlistCount <= 0);
    });
*/
  }
  
  function customEventListeners(swat) {
    document.addEventListener('swym:initializeActionButtons', (e) => {
      swat.initializeActionButtons('body');
    });

    document.addEventListener('swym:updateNav', (e) => {
      updateNav(swat);
    });
  }

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  window.SwymCallbacks.push(updateNav, navUpdateListeners, customEventListeners);

})();
